<template>
	<div class="nav" v-if="user">
		<a href="/">
			<img src="../assets/home_logo.png" alt="">
		</a>
		<div class="right">
			<div class="photo">
				<img :src="user.avatar_src" alt="">
			</div>
			<div class="name">
				你好, {{user.nickname}}
			</div>
			<div class="rank">
				<span style="background-color: #fe5f01;color: white;padding: 0 5px;">
					{{user.rank}}
				</span>
			</div>
			<div class="coins">
				{{user.coins}}
			</div>
			<div class="diamonds">
				{{user.diamonds}}
			</div>
			<div class="exit">
				<span @click="back" class="go-back">返回</span>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios"
export default {
	data() {
		return {
		}
	},
	computed: {
		user() {
			return this.$store.state.user
		}
	},

	created() {
		/*
		this.user = {"id":1,"nickname":"123","password":"","name":"123","registration_code":"123","teacher_id":1,"created_at":"2016-03-08T03:08:09.000+08:00","updated_at":"2017-06-15T16:01:50.000+08:00","class_room_id":null,"rank_score":-2970.0,"total_questions":3473,"today_questions":8779,"last_login_time":"2017-06-15T16:01:50.000+08:00","last_login_ip":"127.0.0.1","one_star_unlocked":true,"two_star_unlocked":true,"three_star_unlocked":false,"current_book":108,"current_section":4,"current_question":2,"sex":"男","is_bgm_on":true,"is_sound_on":false,"need_cross":false,"need_confirm":false,"avartar":"/image/settings/头像3.jpg","four_star_unlocked":false,"five_star_unlocked":false,"six_star_unlocked":false,"seven_star_unlocked":false,"eight_star_unlocked":false,"nine_star_unlocked":false,"ten_star_unlocked":false,"weixin_openid":null,"weixin_unionid":null,"weixin_nickname":null,"weixin_province":null,"weixin_city":null,"weixin_checked_at":null,"city":"","isrobot":false,"finished_one_section_today":true,"coins":28370,"finished_one_challenge_level":true,"unlock_one_new_challenge_level":true,"unlock_one_new_section":true,"diamonds":300,"got_beginner_package":true,"current_star":null,"teacher_account_id":null,"today_total_question_count":81,"today_correct_question_count":79,"today_total_match_count":1,"today_correct_match_count":0,"week_total_question_count":104,"week_correct_question_count":102,"week_total_match_count":6,"week_correct_match_count":0,"month_total_question_count":2194,"month_correct_question_count":2036,"month_total_match_count":35,"month_correct_match_count":1,"history_total_question_count":5578,"history_correct_question_count":3902,"history_total_match_count":198,"history_correct_match_count":21,"is_cheer_up_on":true,"yesterday_total_question_count":0,"yesterday_total_match_count":0,"yesterday_correct_question_count":0,"yesterday_correct_match_count":0,"show_boardsize":0,"complete_one_match":false,"is_support_staff":false,"got_sorry_package":true,"last_one_week_total_question_count":0,"last_one_week_correct_question_count":0,"last_one_week_total_match_count":0,"last_one_week_correct_match_count":0,"last_two_week_total_question_count":0,"last_two_week_correct_question_count":0,"last_two_week_total_match_count":0,"last_two_week_correct_match_count":0,"eleven_star_unlocked":false,"twelve_star_unlocked":false,"history_total_question_count_record":0,"history_correct_question_count_record":0,"history_question_count_record_date":null,"board_size_changed":false,"points_race_points":0,"eeo_tel_num":null,"avatar_src":"/image/settings/头像3.jpg","display_nickname":"123","is_referee":false,"rank":"29.7K"}
		*/
		this.$store.dispatch('updateUser')
	},
	methods: {
		back() {
			if (this.$route.path == '/') {
				location.href = "/"
			}else {
				this.$router.back()
			}
		}
	}
}
</script>

<style scoped>
.nav {
	height: 100px;
	background-color: white;
}
.right {
	float: right;
}
.right > div {
	float: left;
}
.photo {
	box-sizing: border-box;
	margin: 5px;
	width: 90px;
	height: 90px;
	border: 2px solid #7ac5f8;
}
.photo img {
	width: 100%;
	height: 100%;
}
.name {
	line-height: 100px;
	height: 100px;
	margin-right: 20px;
}
.rank {
	line-height: 100px;
	height: 100px;
	margin-right: 20px;
}
.coins {
	background: url(../assets/金币.png) no-repeat center;
	height: 100%;
	width: 129px;
	line-height: 100px;
	box-sizing: border-box;
	padding-left: 50px;
}
.diamonds {
	background: url(../assets/钻石.png) no-repeat center;
	height: 100%;
	width: 129px;
	line-height: 100px;
	box-sizing: border-box;
	padding-left: 60px;
}
.exit {
	line-height: 100px;
	height: 100px;
	margin: 0 20px;
}
.go-back {
	font-size: 1.2em;
	padding: 0 5px;
	color: #4fbffe;
	border: 1px solid #4fbffe;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// HeaderComponent.vue?761bf3a6